// Click-to-play video preview for post listings (feed + admin cards) — same
// R2-native-video / legacy-Stream-iframe split as PostDetail's hero block, just
// sized for a card in a list instead of a full-bleed hero.

export function InlineVideo({
  videoUrl,
  videoStreamUid,
  posterUrl,
}: {
  videoUrl: string | null;
  videoStreamUid: string | null;
  posterUrl?: string | null;
}) {
  if (!videoUrl && !videoStreamUid) return null;

  return (
    <div className="w-full overflow-hidden bg-black" onClick={(e) => e.stopPropagation()}>
      {videoUrl ? (
        <video
          src={videoUrl}
          poster={posterUrl ?? undefined}
          controls
          playsInline
          preload="metadata"
          className="block max-h-96 w-full bg-black"
        />
      ) : (
        <div className="aspect-video w-full">
          <iframe
            src={`https://iframe.videodelivery.net/${videoStreamUid}`}
            title="Video"
            className="h-full w-full"
            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
            allowFullScreen
          />
        </div>
      )}
    </div>
  );
}
